module.exports = __webpack_public_path__ + "img/202410_10.40b996e5.jpg";